// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"HeaderClubBenefits_carousel-container__a9Ipt","carousel-item":"HeaderClubBenefits_carousel-item__t81g1"};